import { z } from 'zod';

/**
 * The organizing committee behind an event.
 *
 * Phase 2 has no per-organization login: this is a label plus the content an
 * organizer wants participants to see after they check in. Authorization is
 * Cloudflare Access on the iRace admin account, nothing more.
 */

/**
 * Only https, and only absolute.
 *
 * These render as links on a page participants open from a printed QR code on
 * a venue network. An http:// link there is a downgrade an operator would
 * never notice and a participant could never audit.
 */
export const HttpsUrlSchema = z
  .url()
  .max(2000)
  .refine((value) => value.startsWith('https://'), 'must be an https:// URL');

export const OrganizationPublicSchema = z.strictObject({
  id: z.string().min(1).max(100),
  name: z.string().min(1).max(200),
  description: z.string().max(2000).nullish(),
  website_url: HttpsUrlSchema.nullish(),
  logo_url: HttpsUrlSchema.nullish(),
});

export const OrganizationSchema = OrganizationPublicSchema.extend({
  created_at: z.iso.datetime({ offset: true }),
  updated_at: z.iso.datetime({ offset: true }),
});

export const OrganizationListSchema = z.array(OrganizationSchema);

export type OrganizationPublic = z.infer<typeof OrganizationPublicSchema>;
export type Organization = z.infer<typeof OrganizationSchema>;
